import React from "react";
import { siteBrandLabel } from "../../utils/siteBrand";
import "./BrandFilter.css";

/**
 * "Brand: All · Stop Pest · Solveary". Renders nothing unless `show` — a tenant
 * with one brand (or none) sees no change. Labels come from utils/siteBrand so
 * the chip, the inbox badge and the scorecard all say the same name.
 */
export default function BrandFilter({ show, brands, value, onChange, note }) {
  if (!show) return null;
  const options = [{ key: "", label: "All" },
    ...brands.map((b) => ({ key: b, label: siteBrandLabel({ site_brand: b }) || b }))];
  return (
    <div className="brand-filter" role="group" aria-label="Brand">
      <span className="brand-filter-label">Brand</span>
      {options.map((o) => (
        <button
          key={o.key || "all"}
          type="button"
          className={`brand-filter-chip${value === o.key ? " is-active" : ""}`}
          aria-pressed={value === o.key}
          onClick={() => onChange(o.key)}
        >
          {o.label}
        </button>
      ))}
      {note && value ? <span className="brand-filter-note">{note}</span> : null}
    </div>
  );
}
